const C = require("../constants");

const taxDialog = (data) => {
    return {
        type: C.TAX_DIALOG,
        data
    }
};

export {taxDialog};


// WEBPACK FOOTER //
// ./src/actions/TaxDialogAction.js